import React from 'react';

import { NumberFieldProps, FieldNumber } from './FieldNumber';

export type CurrencyFieldProps = Omit<NumberFieldProps, 'prefix'>;

export const FieldCurrency = ({ ...props }: CurrencyFieldProps) => (
    <FieldNumber
        {...{
            ...props,
            prefix: '$',
        }}
    />
);
